"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.regionColumns = exports.regionEntityName = exports.jurisdictionColumns = exports.jurisdictionEntityName = exports.genderColumns = exports.genderEntityName = exports.ethnicityColumns = exports.ethnicityEntityName = void 0;
const shared_1 = require("../../../../backend/features/classifiers/shared");
const storage_1 = require("@juvare/platform-shared/features/storage");
exports.ethnicityEntityName = 'ethnicity';
exports.ethnicityColumns = (0, storage_1.defineColumns)({
    ...shared_1.classifierColumns,
    displayOrder: {
        type: 'number',
    },
    search: {
        type: 'full-text-search-required',
        language: 'english',
    },
});
exports.genderEntityName = 'gender';
exports.genderColumns = (0, storage_1.defineColumns)({
    ...shared_1.classifierColumns,
    search: {
        type: 'full-text-search-required',
        language: 'english',
    },
});
exports.jurisdictionEntityName = 'jurisdiction';
exports.jurisdictionColumns = (0, storage_1.defineColumns)({
    name: {
        type: 'string-required',
        index: true,
    },
    defaultName: {
        type: 'string',
        index: true,
    },
    status: {
        type: 'string-required',
        index: true,
    },
    type: {
        type: 'string-required',
        index: true,
    },
    fips: {
        type: 'string',
        index: 'unique',
    },
    postalCode: {
        type: 'string',
        index: 'unique',
    },
    parentName: {
        type: 'string',
        index: true,
    },
    parentPostalCode: {
        type: 'string',
        index: true,
    },
    registerState: {
        type: 'boolean',
        index: true,
    },
    search: {
        type: 'full-text-search-required',
        language: 'english',
    },
});
exports.regionEntityName = 'region';
exports.regionColumns = (0, storage_1.defineColumns)({
    ...shared_1.classifierColumns,
    displayOrder: {
        type: 'number',
    },
    state: {
        type: 'string-required',
    },
    counties: {
        type: 'string-array-required',
    },
    search: {
        type: 'full-text-search-required',
        language: 'english',
    },
});
